// extracted by mini-css-extract-plugin
export var actionButton = "_6h-0";
export var attachmentLine = "_6h-1";
export var fileInput = "_6h-2";
export var fileUploadWrapper = "_6h-4";
export var footer = "_6h-3";
export var modalContent = "_6h-5";
export var paperclip = "_6h-6";
export var quillEditor = "_6h-7";